import { Flex } from '@aloft/toolkit-sui';

import { selectActiveDepreciateSeparatelyID } from '../../../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { DepreciateSeparatelyModalContentComponentsOfValue } from './DepreciateSeparatelyModalContentComponentsOfValue.tsx';
import { DepreciateSeparatelyModalContentHeading } from './DepreciateSeparatelyModalContentHeading.tsx';
import { DepreciateSeparatelyModalContentTotalDepreciation } from './DepreciateSeparatelyModalContentTotalDepreciation.tsx';
import { DepreciateSeparatelySliders } from './DepreciateSeparatelySliders.tsx';

export const DepreciateSeparatelyModalContent = () => {
  const activeId = useAppSelector(selectActiveDepreciateSeparatelyID);

  return (
    <Flex flexDirection="column" height="100%" overflow="auto">
      <DepreciateSeparatelyModalContentHeading
        title="Depreciation"
        informationIconText="Set the effective age to calculate depreciation for each structure.  Note you can set default economic life for each structure within settings."
      />
      <DepreciateSeparatelySliders activeId={activeId} />
      <DepreciateSeparatelyModalContentTotalDepreciation activeId={activeId} />
      <DepreciateSeparatelyModalContentHeading title="Components of Value" />
      <DepreciateSeparatelyModalContentComponentsOfValue activeId={activeId} />
    </Flex>
  );
};
